export default resolvedMappings =>
	function getResolvedPropertyValue(key) {
		return resolvedMappings.get(key);
	};
